module.exports = __webpack_public_path__ + "img/slide13.8c4b001c.png";